<template>
    <el-dialog title="选择部门" v-loading="selectLoading" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false" top="5%">
        <sy-baselist
                :filters="filters"
                :hideAdd="true"
                :hideEdit="true"
                :hideDel="true"
                :showSelect="true"
                @onSelect="onSelect"
                listUrl="server/system/Dept.ashx?cmd=GetList"
        >

            <el-table-column prop="name" label="部门名称" width="150" sortable>
            </el-table-column>
            <el-table-column prop="note" label="备注" width="200" sortable>
            </el-table-column>

        </sy-baselist>
    </el-dialog>
</template>

<script>
    import util from '../../common/util'
    export default {
        data(){
            return {
                selectLoading:false,
                FRoleID:0,
                editFormVisible:false,
                filters: [{type: "string",name:"name",text:"部门名称", value: ""}]
            }
        },
        methods:{
            switchLoading(flag){
                this.selectLoading = flag;
            },
            _openAdd(row) {
                this.editFormVisible = true
                this.FRoleID = row.roleId
            },
            onSelect(row){
                let form={
                    roleId:this.FRoleID,
                    deptId:row.id
                }
                util.post("server/system/Role.ashx?cmd=SaveRoleDept",form,this.switchLoading,result=> {
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",row)
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/system/Dept_Select.vue